module.exports = __webpack_public_path__ + "fonts/Nunito-Light.6a4fadd.ttf";